import { Component } from '@angular/core';
import { ValueReferenceService } from '../crud-service';
import { ValueReferenceCrudIndex } from './crud-index';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { FormGroup, Validators } from '@angular/forms';
import { take } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { ValueReferenceIndexSelectComponent } from './crud-index-select.component';
import { FileTypeEnum, FileTypeIdEnum } from 'src/app/domain/registration/enums/file-type.enum';
import { ValueReferenceTypeEnum } from 'src/app/domain/registration/enums/value-reference-type.enum';

@Component({
  selector: 'app-valueReference-index',
  templateUrl: './crud-index.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [ValueReferenceService],
})
export class ValueReferenceIndexComponent extends ValueReferenceCrudIndex {
  ngOnInit(): void {}

  override filterFields: IFieldConfig[] = [
    {
      type: TypeComponentFieldEnum.INPUT,
      label: 'Nome',
      name: 'name',
      value: '',
    },
    {
      type: TypeComponentFieldEnum.SELECT,
      label: 'TIPO',
      name: 'type',
      options: Object.values(ValueReferenceTypeEnum),
      placeholder: 'Selecione uma opção',
      validation: [Validators.required],
    }
  ];

  override submitAdvancedFilter(filterForm: FormGroup) {
    let _filterForm = this.getFilters(filterForm.value);
    this.service
      .findByFilter(_filterForm, this.params)
      .pipe(take(1))
      .subscribe((dataWithPagination: any) => {
        let data = dataWithPagination[0];
        this.length = dataWithPagination[1];
      });
  }

  private getFilters(filter: any) {
    let params: any = {};

    // Filtro pelo nome
    if (filter.name) params.name = filter.name.trim;

    return params;
  }


  private formatDate(dateString: string): string {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); 
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
}
